<app-service-overview [subscription]="subscription" [tenants]="trialOfferData?.tenants"
                      [terms]="trialOfferData?.terms"
    [trialOfferType]="trialOfferType" (subscribeTrial)="subscribeTrial($event)"
    (request)="onRequestAccess($event)"></app-service-overview>
